import { memo } from 'react';
import { Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../constants';

interface BlockTitleProperties {
  title: string;
}

const BlockTitle = memo(({ title }: BlockTitleProperties) => (
  <Text
    as='h1'
    fontFamily='Comfortaa Bold'
    fontSize={BUILDER_MODE_V1_LAYOUT.titleFontSize}
    fontWeight='700'
    lineHeight={BUILDER_MODE_V1_LAYOUT.titleLineHeight}
    h={BUILDER_MODE_V1_LAYOUT.titleLineHeight}
    color={BUILDER_MODE_V1_TOKENS.textDark}
    whiteSpace='nowrap'
    m={0}
    display='flex'
    alignItems='center'
  >
    {title}
  </Text>
));

BlockTitle.displayName = 'BlockTitle';

export default BlockTitle;
